export const fields = {
  comment: {
    label: "Comment",
    type: "text",
    rules: "required|string",
  },
};
